import { render, staticRenderFns } from "./message-chat-bubble.vue?vue&type=template&id=13add588&scoped=true"
import script from "./message-chat-bubble.vue?vue&type=script&lang=js"
export * from "./message-chat-bubble.vue?vue&type=script&lang=js"
import style0 from "./message-chat-bubble.vue?vue&type=style&index=0&id=13add588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13add588",
  null
  
)

export default component.exports